/**
 * Hold-and-replay buffer for Meta events fired before the guest has decided.
 *
 * Three consent states, not two:
 *   undecided  no cookie yet. Queueable events are held.
 *   granted    fire immediately, and flush whatever is held.
 *   declined   drop. A guest who declined and later grants starts fresh:
 *              replaying an hour of held events at the moment of grant is not
 *              what "express prior consent" means.
 *
 * A queued entry is a closure over the fully built arguments, captured at the
 * moment of the action, so a replayed event carries the value and the room the
 * guest actually saw rather than whatever the app looks like at flush time.
 */

import { MAX_QUEUED_EVENTS } from '../../constants/analytics';


let queued = [];

export function enqueue(thunk) {
  // At the cap, keep the head of the journey and drop the newest: the first
  // steps are what explain where a guest came from.
  if (queued.length >= MAX_QUEUED_EVENTS) return false;
  queued.push(thunk);
  return true;
}

export function flush() {
  const pending = queued;
  queued = [];
  pending.forEach((thunk) => {
    try {
      thunk();
    } catch (e) {
      // A replayed event must not break the consent interaction either.
    }
  });
  return pending.length;
}

export function clear() {
  const dropped = queued.length;
  queued = [];
  return dropped;
}

export function size() {
  return queued.length;
}
